import api from "./api";

// 视频删除
export const videoDelete = async (id: string) => {
  const res = await api.post<unknown>("/video/delete", { id });
  return res;
};
